import UserAccountResource  from 'resources/user/UserAccountResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class WalletResource extends UserAccountResource {
  static urlRoot = '/auth/wallets'
}
